import {
  faCalendar,
  faCar,
  faCheck,
  faCheckCircle,
  faClock,
  faCopy,
  faHourglassEnd,
  faIdCard,
  faInfo,
  faPhone,
  faUserCheck,
  faUserTie,
} from "@fortawesome/fontawesome-free-solid";
import {
  faArrowRightArrowLeft,
  faCircleInfo,
  faLayerGroup,
  faLocationDot,
  faSignsPost,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import momenttz from "moment-timezone";
import copy from "copy-to-clipboard";
import BookingDetailItem from "./BookingDetailItem";
import moment from "moment";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { set } from "lodash";
import { Edit, EditAttributes, Save } from "@material-ui/icons";
import { IconButton, Tooltip } from "@mui/material";
import { CreditCardIcon, PencilIcon } from "@heroicons/react/solid";
import { Close } from "@mui/icons-material";
import Modal from "../Modal";
import { setQuoteBy } from "../../../redux/app/booking/booking-slice";

const ManageBookingItem = ({
  bookingId,
  Bookingtype,
  createdAt,
  extraHour,
  pickupLocation,
  dropofLocation,
  travelDate,
  travelDistance,
  travelTime,
  amount,
  extraPay,
  totalPayment,
  groupBookingMark,
  groupId,
  groupBookingObj,
  currency,
  vehicleImage,
  vehicletype,
  bookingStatus,
  userName,
  affiliateDetails,
  duration,
  driverDetails,
  spreq,
  onClickedCheckbox,
  isBulkAssign,
  isGroup,
  onChangePurchaseCurrency,
  onChangePurchasePrice,
  onChangePPNote,
  affiliateDetailsAssignedArr,
  bookingFor,
  quoteBy,
  invoiceNum,
  passengerFirstName,
  passengerLastName,
  indianDate,
  indianTime,
  affiliatePaymentStatus,
  ObjectBookingId
}) => {
  const [copyMsg, setcopyMsg] = useState(false);
  const [affiliateName, setaffiliateName] = useState();
  const dispatch = useDispatch();
  const [editBookfor, seteditBookfor] = useState(false);
  const [editQuoteBy, setEditQuoteBy] = useState(false);

  // console.log("editQuoteBy===>", editQuoteBy);
  const handleQuoteBy = (e) => {
    dispatch(setQuoteBy({ quotedBy: quoteBy }));
    setEditQuoteBy(true);
  };

  useEffect(() => {
    setTimeout(() => {
      setcopyMsg(false);
    }, 5000);
  }, [copyMsg]);
  const { allCompany, companyDetails } = useSelector((state) => state.company);
  const { quotedBy } = useSelector((state) => state.booking);
  const { token, user } = useSelector((state) => state.auth);
  const [bookForBody, setbookForBody] = useState();
  const handleClick = (id) => () => {
    copy(id);
    setcopyMsg(true);
  };

  const [bookingForUPdate, setbookingForUPdate] = useState();

  const [showUsername, setShowUsername] = useState(false);
  let timeoutId;
  const handleIconHover = () => {
    clearTimeout(timeoutId);
    setShowUsername(true);
  };

  const handleIconLeave = () => {
    timeoutId = setTimeout(() => {
      setShowUsername(false);
    }, 600);
  };

  const handleTooltipHover = () => {
    clearTimeout(timeoutId);
  };

  const handleTooltipLeave = () => {
    timeoutId = setTimeout(() => {
      setShowUsername(false);
    }, 300);
  };

  return (
    <>
      {editQuoteBy && (
        <>
          <Modal
            isQuoteBy={editQuoteBy}
            cancelOnClick={() => {
              setEditQuoteBy(false);
              dispatch(setQuoteBy({ quotedBy: "" }));
            }}
            addButtonLabel={"Update"}
            addOnClick={() => {
              dispatch({
                type: "UPDATE_BOOKING",
                payload: {
                  body: {
                    bookingId: bookingId,
                    quoteBy: quotedBy,
                  },
                  token,
                  msg: "Quote by added Successfully",
                },
              });
              setEditQuoteBy(false);
              dispatch(setQuoteBy({ quotedBy: "" }));
            }}
          />
        </>
      )}
      <div className="relative xl:hidden block mx-3 sm:mx-4 lg:mx-5 mt-10 rounded-md border border-gray-200">
        <div className="">
          <div className="px-3 py-2 relative bg-gray-100 border-b-[1px] space-y-1">
            <div className="flex space-x-1 items-center">
              <div className="text-xs font-semibold text-primary font-body">
                Booking ID:
              </div>
              <div className="text-xs text-[#fb4156] font-body">
                {bookingId}
              </div>
              <span onClick={handleClick(bookingId)}>
                <FontAwesomeIcon
                  icon={faCopy}
                  className="w-3 cursor-pointer text-gray-700 pl-1"
                />
              </span>
              {copyMsg && (
                <div className="text-xs italic text-gray-500 animate__animated animate__fadeIn absolute translate-x-52">
                  Copied
                </div>
              )}
            </div>

            <div className="text-sm flex space-x-2 items-center">
              <div className="text-sm font-semibold text-primary font-body">
                Booked By
              </div>
              {userName.includes("Offline") ? (
                <>
                  <div className="flex space-x-3">
                    <div className="text-sm text-gray-700">
                      {userName.split(" ")[0]}
                    </div>
                    <div className="text-orange-500 tracking-wider">
                      {userName.split(" ")[1]}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="text-sm text-gray-700">{userName}</div>
                </>
              )}
            </div>
            <div className="flex items-center justify-between space-x-3">
              <div className="flex items-center space-x-1">
                <div className="text-sm font-semibold">{currency}</div>
                <div className="text-sm font-semibold text-secondary">
                  {Math.round(amount)}
                </div>
              </div>
              <div className="text-xs text-secondary">{vehicletype}</div>
            </div>
            <div className="mt-0 space-y-2 absolute -top-10 -right-3 z-10">
              <img src={vehicleImage} alt="" className="w-32 " />
            </div>
          </div>
          <div className="px-3 py-2">
            <Link to={`/manageBooking/${bookingId}`}>
              <div className="py-1 justify-between cursor-pointer">
                <div className="space-y-2">
                  <BookingDetailItem
                    iconname={faLocationDot}
                    label="Pick Up"
                    value={pickupLocation}
                  />
                  <BookingDetailItem
                    iconname={faLocationDot}
                    label="Drop Off"
                    value={dropofLocation}
                  />
                  <BookingDetailItem
                    iconname={faArrowRightArrowLeft}
                    label="Booking Type"
                    value={
                      Bookingtype?.charAt(0)?.toUpperCase() +
                      Bookingtype?.slice(1).toLowerCase()
                    }
                  />
                  <BookingDetailItem
                    iconname={faArrowRightArrowLeft}
                    label="Passenger Name"
                    value={`${passengerFirstName} ${passengerLastName}`}
                  />
                  <BookingDetailItem
                    iconname={faCalendar}
                    label="Travel Date"
                    value={`${
                      travelDate
                        ? moment(travelDate?.split("T")[0]).format(
                            "DD MMM YYYY"
                          ) +
                          " | Time: " +
                          travelTime
                        : ""
                    } 
                    `}
                  />

                  {user?.role === "ADMIN" && (
                    <>
                      <BookingDetailItem
                        iconname={faCalendar}
                        label="Indian Date"
                        value1={`${
                          indianDate && indianTime
                            ? `IST - ${moment(indianDate).format(
                                "DD MMM YYYY"
                              )} | ${indianTime}`
                            : ""
                        }`}
                      />
                    </>
                  )}

                  <BookingDetailItem
                    iconname={faSignsPost}
                    label="Distance"
                    value={Math.round(travelDistance) + " km"}
                  />
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>

      {/* --------------------- screen size from lg -------------------------- */}

      <div className="hidden xl:block ml-2 mr-10 xl:mr-2 2xl:mx-5 mt-3 rounded-md border border-gray-200 shadow-lg hover:shadow-xl">
        <div className="flex justify-between w-full bg-gray-200 px-5 2xl:pr-0 py-1 relative">
          {affiliateDetailsAssignedArr.map(
            (item) =>
              item.bookingId === bookingId && (
                <div className="bg-white animate__animated animate__fadeInRight shadow-xl rounded-md translate-x-1/2 mx-auto flex justify-center h-auto absolute left-20 z-10">
                  <div className="flex justify-between space-x-5 px-5 py-3">
                    <div>
                      <div className="text-sm">Purchase Currency</div>
                      <input
                        type="text"
                        className="border-b-2 focus:outline-none grow textField w-32"
                        onChange={onChangePurchaseCurrency}
                      />
                    </div>
                    <div>
                      <div className="text-sm">Purchase Price</div>
                      <input
                        onChange={onChangePurchasePrice}
                        type="text"
                        className="border-b-2 focus:outline-none grow textField w-32"
                      />
                    </div>
                    <div>
                      <div className="text-sm">PP note</div>
                      <textarea
                        onChange={onChangePPNote}
                        type="text"
                        className="border-b-2 focus:outline-none grow textField"
                      />
                    </div>
                  </div>
                </div>
              )
          )}

          <div className="flex space-x-1 items-center relative xl:w-1/4">
            {isBulkAssign && (
              <input
                type="checkbox"
                onClick={onClickedCheckbox}
                value={
                  affiliateDetailsAssignedArr.filter(
                    (item) => item.bookingId === bookingId
                  ).length > 0
                }
              />
            )}

            {isGroup && (
              <input
                type="checkbox"
                onClick={onClickedCheckbox}
                checked={Object.keys(groupBookingObj).includes(bookingId)}
                // value={Object.keys(groupBookingObj).includes(bookingId)}
              />
            )}

            <div>
              <div className="flex space-x-2 items-center">
                <div className="font-normal text-xs text-gray-700 font-body">
                  ID:
                </div>
                <div className="text-xs font-semibold text-primary font-body">
                  {bookingId}
                </div>
                <span onClick={handleClick(bookingId)}>
                  <FontAwesomeIcon
                    icon={faCopy}
                    className="w-3 cursor-pointer text-gray-700 pl-3"
                  />
                </span>
                {!invoiceNum?.slice("-").includes("DIO") &&
                  user.role === "ADMIN" && (
                    <Tooltip title="Invoiced">
                      <FontAwesomeIcon
                        icon={faCheckCircle}
                        className="w-6 cursor-pointer  text-teal-600 pl-3"
                      />
                    </Tooltip>
                  )}
                {affiliatePaymentStatus === "PBI" ||
                affiliatePaymentStatus === "PRP" ? (
                  <Tooltip title="Affiliate Payment Complete">
                    <CreditCardIcon className="w-6 h-6 text-green-700 " />
                  </Tooltip>
                ) : (
                  affiliateDetails?.affiliateName &&
                  (affiliatePaymentStatus !== "PBI" ||
                    affiliatePaymentStatus !== "PRP") &&
                  user.role === "ADMIN" && (
                    <Tooltip title="Affiliate Payment Pending">
                      <FontAwesomeIcon
                        icon={faWarning}
                        className={`w-6 cursor-pointer  text-red-600 animate-flashs pl-3`}
                      />
                    </Tooltip>
                  )
                )}

                {groupBookingMark && user?.role === "ADMIN" && (
                  <Tooltip title="Grouped">
                    <FontAwesomeIcon
                      icon={faLayerGroup}
                      className="w-6 cursor-pointer  text-slate-500 pl-3"
                    />
                  </Tooltip>
                )}
                {copyMsg && (
                  <div className="text-xs italic  text-gray-500 animate__animated animate__fadeIn absolute translate-x-60">
                    Copied
                  </div>
                )}
              </div>

              {groupBookingMark && user?.role === "ADMIN" && (
                <div className="flex space-x-2 pt-1 items-center">
                  <div className=" text-xs text-stone-700 font-semibold font-body">
                    G-ID:
                  </div>
                  <div className="text-sm font-semibold text-stone-600 font-body">
                    {groupId}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div>
            {user?.role === "ADMIN" && (
              <div className="flex space-x-2 items-center text-xs ">
                <div className="italic font-semibold text-gray-600 font-body">
                  Booked for
                </div>
                {!editBookfor && bookingFor ? (
                  <div className="flex space-x-1">
                    <div className="text-xs text-gray-700">{bookingFor}</div>
                    {invoiceNum?.slice("-").includes("DIO") && (
                      <>
                        <Tooltip title="Edit">
                          <PencilIcon
                            className="w-5 cursor-pointer"
                            onClick={() => {
                              seteditBookfor(true);
                            }}
                          />
                        </Tooltip>
                      </>
                    )}
                  </div>
                ) : (
                  <>
                    <Select
                      options={allCompany.map((item) => ({
                        value: item,
                        label: item.companyName,
                      }))}
                      // value={bookingFor}
                      onChange={(e) => {
                        let body = {
                          bookingId: bookingId,
                          bookingFor: e.value.companyName,
                        };

                        setbookForBody(body);
                      }}
                    />
                    <Tooltip title="Save">
                      <IconButton
                        onClick={() => {
                          dispatch({
                            type: "UPDATE_BOOKING",
                            payload: {
                              body: bookForBody,
                              token,
                              msg: "Booking for added Successfully",
                            },
                          });
                          dispatch({
                            type: "BOOKING_HISTORY_CREATE",
                            payload: {
                              body: {
                                booking: ObjectBookingId,
                                userName: user?.userName,
                                updateItem: "Booked For",
                                prevValue: bookingFor,
                                currentValue: bookForBody?.bookingFor,
                              },
                              token,
                              bookingId: ObjectBookingId,
                            },
                          });
                        }}
                      >
                        <Save color="primary" />
                      </IconButton>
                    </Tooltip>
                    {bookingFor && (
                      <Tooltip title="Close">
                        <Close
                          className="w-5"
                          onClick={() => {
                            seteditBookfor(false);
                          }}
                        />
                      </Tooltip>
                    )}
                  </>
                )}
              </div>
            )}
            {/* Quatation update */}
            {user?.role === "ADMIN" && (
              <div className="flex space-x-3 items-center text-xs">
                <div className="italic font-semibold text-gray-600 font-body">
                  Quote by
                </div>
                <div className="flex space-x-1 items-end">
                  {!editQuoteBy && quoteBy ? (
                    <div>
                      <div className="text-xs text-gray-700">{quoteBy}</div>
                    </div>
                  ) : (
                    <div>
                      <div className="text-xs text-gray-700 border-b border-black w-28"></div>
                    </div>
                  )}

                  <Tooltip title="Edit">
                    <PencilIcon
                      className="w-5 cursor-pointer"
                      onClick={() => {
                        handleQuoteBy();
                      }}
                    />
                  </Tooltip>
                </div>
                {/* {!editQuoteBy && quoteBy ? (
                  <div className="flex space-x-1">
                    <div className="text-xs text-gray-700">{quoteBy}</div>
                    <Tooltip title="Edit">
                      <PencilIcon
                        className="w-5 cursor-pointer"
                        onClick={() => {
                          setEditQuoteBy(true);
                        }}
                      />
                    </Tooltip>
                  )}
                </>
              )}
            </div>
          )}
          <div className="flex space-x-2 items-center text-sm xl:w-[30%] relative">
            <div className="flex items-center space-x-2 italic font-semibold text-gray-600 font-body">
              <h2>Booked By</h2>{" "}
              <span
                onMouseEnter={handleIconHover}
                onMouseLeave={handleIconLeave}
                className="bg-white border border-slate-300 shadow-md text-black w-5 h-5 rounded-full text-center leading-3"
              >
                <FontAwesomeIcon
                  icon={faInfo}
                  className="text-[12px] text-[#fb4156] italic font-medium pt-[2px]"
                />
              </span>
                  </div>
                ) : (
                  <div className="flex items-center">
                    <Select                      
                      options={companyDetails?.users?.map((item) => ({
                        value: item,
                        label: item.userName,
                      }))}
                      // value={bookingFor}
                      onChange={(e) => {                        
                        let body = {
                          bookingId: bookingId,
                          quoteBy: e.value.userName,
                        };

                        setEditQuoteBy(body);
                      }}
                    />
                    <Tooltip title="Save">
                      <IconButton
                        onClick={() => {
                          dispatch({
                            type: "UPDATE_BOOKING",
                            payload: {
                              body: editQuoteBy,
                              token,
                              msg: "Quote by added Successfully",
                            },
                          });
                        }}
                      >
                        <Save color="primary" />
                      </IconButton>
                    </Tooltip>
                    {quoteBy && (
                      <Tooltip title="Close">
                        <Close
                          className="w-5"
                          onClick={() => {
                            setEditQuoteBy(false);
                          }}
                        />
                      </Tooltip>
                    )}
                  </div>
                )} */}
              </div>
            )}
          </div>

          <div className="relative flex space-x-2 items-center text-sm xl:w-[30%] z-0">
            <div className="flex items-center space-x-2 italic font-semibold text-gray-600 font-body">
              <h2>Booked By</h2>
              <div
                onMouseEnter={handleIconHover}
                onMouseLeave={handleIconLeave}
                className="bg-white border border-slate-300 shadow-md text-black w-5 h-5 rounded-full text-center leading-3"
              >
                <FontAwesomeIcon
                  icon={faInfo}
                  className="text-[12px] text-[#fb4156] italic font-medium pt-[2px]"
                />
              </div>
            </div>
            {showUsername && (
              <div
                className="absolute left-24 z-50 text-white font-body bg-gray-900 px-3 py-1.5 rounded-md shadow-md"
                onMouseEnter={handleTooltipHover}
                onMouseLeave={handleTooltipLeave}
                style={{
                  whiteSpace: "nowrap",
                  // transform: "translateX(50%)",
                }}
              >
                {userName.includes("Offline") ? (
                  <div className="flex space-x-3">
                    <div className="text-sm">{userName.split(" ")[0]}</div>
                    <div className="text-orange-500 tracking-wider">
                      {userName.split(" ")[1]}
                    </div>
                  </div>
                ) : userName.includes("cloned") ? (
                  <div className="flex space-x-3">
                    <div className="text-sm">{userName.split(" ")[0]}</div>
                    <div className="text-green-500 tracking-wider">
                      {userName.split(" ")[1]}
                    </div>
                  </div>
                ) : (
                  <div className="text-sm">{userName}</div>
                )}
              </div>
            )}
          </div>
          <div className="z-0">
            <div className="flex items-center space-x-3 xl:justify-start 2xl:justify-center 3xl:justify-start 2xl:pl-1 3xl:pr-5 xl:w-1/5">
              <div className="flex items-center space-x-1">
                <div className="text-sm font-bold font-body">Price:</div>
                <div className="text-base font-bold font-body">{currency}</div>
                <div className="text-2xl font-bold text-secondary font-body">
                  {Math.round(amount)}
                </div>
              </div>
            </div>
            {extraPay && (
              <div className="text-sm min-w-max bg-white border border-slate-300 text-black px-2 py-2 rounded-md mr-2 font-bold mb-1">
                {" "}
                + {extraPay} ={" "}
                <span className="font-bold">
                  {" "}
                  {currency} {totalPayment}{" "}
                </span>{" "}
                <span> / {extraHour} hours</span>
              </div>
            )}
          </div>
        </div>
        {/* secondary details */}
        <Link to={`/manageBooking/${bookingId}`}>
          <div className="py-3 px-5 flex justify-between cursor-pointer">
            <div className="xl:w-2/5 2xl:w-full space-y-2">
              <BookingDetailItem
                iconname={faLocationDot}
                label="Pick Up"
                value={pickupLocation}
              />
              <BookingDetailItem
                iconname={faLocationDot}
                label="Drop Off"
                value={dropofLocation}
              />
              <BookingDetailItem
                iconname={faUserCheck}
                label="Passenger Name"
                value={`${passengerFirstName} ${passengerLastName}`}
              />

              <BookingDetailItem
                iconname={faArrowRightArrowLeft}
                label="Booking Type"
                value={
                  Bookingtype?.charAt(0)?.toUpperCase() +
                  Bookingtype?.slice(1).toLowerCase()
                }
              />

              <BookingDetailItem
                iconname={faCheckCircle}
                label="Special Request"
                value={spreq}
              />
              {/* <BookingDetailItem
                iconname={faHourglassEnd}
                label="Duration"
                value={duration}
              />
              <BookingDetailItem
                iconname={faSignsPost}
                label="Distance"
                value={Math.round(travelDistance) + " km"}
              /> */}
              <BookingDetailItem
                iconname={faSignsPost}
                label="Distance & Duration"
                value={`${Math.round(travelDistance) + " km"} | ${
                  duration !== undefined ? duration : ""
                }`}
              />
            </div>
            <div className="xl:w-2/5 2xl:w-full space-y-2">
              {/* <BookingDetailItem
                iconname={faCalendar}
                label="Booking Date"
                value={moment(createdAt).format("DD MMM YYYY")}
              /> */}
              {/* <BookingDetailItem
                iconname={faUserCheck}
                label="Passenger Name"
                value={`${passengerFirstName} ${passengerLastName}`}
              /> */}
              <BookingDetailItem
                iconname={faUserCheck}
                label="Travel Date"
                value={`${moment(travelDate?.split("T")[0]).format(
                  "DD MMM YYYY"
                )}
                `}
              />
              <BookingDetailItem
                iconname={faUserCheck}
                label="Travel Time"
                value={`${travelTime}`}
                value2={
                  user?.role === "ADMIN"
                    ? ` ${
                        indianDate && indianTime
                          ? ` ( IST - ${indianTime} | ${moment(
                              indianDate
                            ).format("DD MMM YYYY")} )`
                          : ""
                      }`
                    : ""
                }
              />

              {/* <BookingDetailItem
                iconname={faCalendar}
                label="Travel Date & Time"
                value={`${
                  moment(travelDate).format("DD MMM YYYY") +
                  " | Time: " +
                  travelTime
                } ${
                  indianDate && indianTime
                    ? ` (IST - ${moment(indianDate).format(
                        "DD MMM YYYY"
                      )} | ${indianTime})`
                    : ""
                }`}
              /> */}
              {/* <BookingDetailItem
                iconname={faClock}
                label="Travel Time"
                value={
                        bookingDetailsById?.passengerDetails?.firstName +
                        " " +
                        bookingDetailsById?.passengerDetails?.lastName
                      }
              /> */}

              {/* <BookingDetailItem
                iconname={faClock}
                label="Travel Time"
                value={travelTime}
              /> */}

              <div className="flex items-center space-x-3">
                <FontAwesomeIcon icon={faCheck} className="w-5 text-gray-400" />
                <div className="text-sm text-slate-700 w-[6.6rem] xl-2:w-36 2xl:w-36 font-bold font-body">
                  Booking Status{" "}
                </div>
                <div
                  className={`${
                    bookingStatus === "COMPLETED"
                      ? "text-yellow-600"
                      : bookingStatus === "CANCELLED"
                      ? "text-red-600"
                      : bookingStatus === "CONFIRMED"
                      ? "text-green-600"
                      : bookingStatus === "POB"
                      ? "text-blue-500"
                      : bookingStatus === "NOSHOW"
                      ? "text-orange-500"
                      : "text-gray-500"
                  } text-gray-700 font-bold text-sm font-body flex  `}
                >
                  <span>{bookingStatus} </span>
                  {bookingStatus === "POB" && (
                    <div>
                      <div class="relative px-1">
                        {/* <div class="w-16 h-16 bg-white rounded-lg shadow-2xl"></div> */}
                        <div class="absolute top-0 right-0 -mr-1 -mt-1 w-3 h-3 rounded-full bg-blue-300 animate-ping"></div>
                        <div class="absolute top-0 right-0 -mr-1 -mt-1 w-3 h-3 rounded-full bg-blue-400"></div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {user?.role === "ADMIN" && (
                <BookingDetailItem
                  iconname={faIdCard}
                  label="Assigned to "
                  value={affiliateDetails?.affiliateName}
                />
              )}
              <BookingDetailItem
                iconname={faUserTie}
                label="Driver Name"
                value={driverDetails?.name}
              />
              <BookingDetailItem
                iconname={faPhone}
                label=" Contact No"
                value={
                  (driverDetails?.countryCode !== undefined
                    ? driverDetails?.countryCode
                    : "") +
                  " " +
                  (driverDetails?.contactNumber !== undefined
                    ? driverDetails?.contactNumber
                    : "")
                }
              />
            </div>
            <div className="xl:w-1/5 2xl:w-full mt-0 flex xl:justify-end 2xl:justify-center 3xl:justify-end space-y-2">
              <div>
                <img
                  src={vehicleImage}
                  alt=""
                  className="w-52 xl:w-44 h-auto "
                />
                <div className="flex xl:flex-col 3xl:flex-row space-x-2 items-center">
                  <div className="flex space-x-2 items-center">
                    <FontAwesomeIcon icon={faCar} className="text-gray-600" />
                    <div className="text-sm font-bold text-gray-600 font-body">
                      Vehicle Type:
                    </div>
                  </div>
                  <div className="font-bold text-secondary font-body">
                    {vehicletype}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};

export default ManageBookingItem;
